<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import config from "../../../config/config";
import { mapGetters, mapActions } from "vuex";
//import pagination from "laravel-vue-pagination";
import { error_message, success_message, debounce } from "../../../state/helpers";

/**
 * Starter component
 */
export default {
  page: {
    title: "Content Page",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  computed: mapGetters("page", ["getAllPage", "loading", "pageCount", "pagination"]),
  data() {
    return {
      sortBy: "id",
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 1,
      search: "",
      perPages: 5,
      config: config,
      searchData: debounce(() => {
        this.getContentPage();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "page_name",
          label: "Page Name",
          sortable: true,
        },
        {
          key: "page_title",
          label: "Page Title",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.getContentPage();
  },
  methods: {
    ...mapActions("page", ["getPages", "deletePage"]),
    getContentPage(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getPages(filters);
    },

    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getContentPage();
    },
    deleteById(id) {
      if (confirm("Are you sure you want to delete this content page")) {
        this.deletePage({ id: id }).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.msg);
            this.getContentPage();
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left d-flex align-items-center">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-tag"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">Content Pages ({{ pageCount }})</h4>
          </div>
          <div class="page-title-right">
            <router-link
              :to="{ name: 'content-page-add' }"
              class="btn btn-primary btn-rounded mr-2 add-btn"
            >
              <i class="mdi mdi-plus mr-1"></i>
              Add Content Page
            </router-link>
            <a
              :href="config.appurl + 'download-content-page-data'"
              class="btn btn-primary btn-md btn-rounded ml-1"
            >
              Download All Data
            </a>
          </div>
          <div class="col-md-6">
            <div class="row justify-content-end">
              <div class="col-sm-6">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Per Page :</label>
                    <select
                      class="custom-select"
                      v-model="perPages"
                      @change="searchData()"
                    >
                      <option value="5" selected>5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="date-range-list">
                  <label>Search :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="$t('navbar.search.text')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 list-table-main">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-6">
                <div class="form-group">
                  <div class="date-range-list">
                    <!-- <label>Per Page :</label>
                                        <select class="custom-select" v-model="perPage" @change="searchData()">
                                            <option value="10" selected>10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-main-list customer-table table-responsive">
                <b-table
                  :items="getAllPage || []"
                  :fields="fields"
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <router-link
                      :to="{
                        name: 'content-page-edit',
                        params: { id: base64(data.item.id) },
                      }"
                      class="btn btn-success btn-sm btn-rounded"
                      >Edit
                    </router-link>
                    <a
                      :href="
                        config.appurl +
                        'page/' +
                        data.item.page_title.toLowerCase().replaceAll(' ', '-') +
                        '/' +
                        base64(data.item.id)
                      "
                      class="btn btn-primary btn-sm btn-rounded ml-1"
                      target="_blank"
                    >
                      View
                    </a>
                    <button
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="deleteById(base64(data.item.id))"
                    >
                      Delete
                    </button>
                  </template>
                  <template #empty>
                    <p class="text-center">{{ $t("Page not found") }}</p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getContentPage"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
